module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "专业名称"
    },
    model: {
      value: (_vm.queryForm.majorCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "majorCode", $$v)
      },
      expression: "queryForm.majorCode"
    }
  }, _vm._l((_vm.comboData.major), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "年级名称"
    },
    model: {
      value: (_vm.queryForm.gradeCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "gradeCode", $$v)
      },
      expression: "queryForm.gradeCode"
    }
  }, _vm._l((_vm.comboData.grade), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")])], 1), _vm._v(" "), (_vm.showTableFlag) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tableLoading),
      expression: "tableLoading"
    }],
    ref: "mainTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "信息加载中",
      "highlight-current-row": "",
      "border": "",
      "height": "530"
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50",
      "align": "center",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.currentPage - 1) * _vm.limit + scope.$index + 1))])]
      }
    }], null, false, 2799227377)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "专业名称",
      "prop": "majorName",
      "align": "center",
      "width": "200px",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "年级名称",
      "prop": "gradeName",
      "align": "center",
      "width": "100px",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "班级名称",
      "prop": "className",
      "align": "center",
      "width": "200px",
      "fixed": ""
    }
  }), _vm._v(" "), _vm._l((_vm.comboData.courseAttr.length), function(index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "label": _vm.comboData.courseAttr[index - 1].comboName + '学分',
        "prop": 'credit' + index,
        "formatter": _vm.creditFormatter,
        "align": "center"
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "总学分",
      "prop": "totalCredit",
      "formatter": _vm.creditFormatter,
      "align": "center",
      "width": "100px",
      "fixed": "right"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "100px",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.setGraduateRequire(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        }), _vm._v(" 编辑\n                ")])]
      }
    }], null, false, 2570252734)
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handlePageChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "毕业要求设置",
      "visible": _vm.settingDialogVisible,
      "width": "900px",
      "top": "120px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.settingDialogVisible = $event
      },
      "closed": _vm.closeSettingDialog
    }
  }, [_c('el-form', {
    ref: "settingForm",
    attrs: {
      "model": _vm.settingForm,
      "label-width": "200px",
      "label-position": "left",
      "rules": _vm.settingRules,
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专业名称",
      "prop": "majorName"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "195px"
    }
  }, [_vm._v(_vm._s(_vm.settingForm.majorName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年级名称",
      "prop": "gradeName"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "195px"
    }
  }, [_vm._v(_vm._s(_vm.settingForm.gradeName))])]), _vm._v(" "), _vm._l((_vm.comboData.courseAttr.length), function(index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": _vm.comboData.courseAttr[index - 1].comboName + '学分',
        "prop": 'credit' + index
      }
    }, [_c('el-input-number', {
      staticStyle: {
        "width": "195px"
      },
      attrs: {
        "min": 0,
        "precision": 3,
        "step": 0.5,
        "label": '请输入' + _vm.comboData.courseAttr[index - 1].comboName + '学分'
      },
      model: {
        value: (_vm.settingForm['credit' + index]),
        callback: function($$v) {
          _vm.$set(_vm.settingForm, 'credit' + index, $$v)
        },
        expression: "settingForm['credit'+index]"
      }
    })], 1)
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "总学分",
      "prop": "totalCredit"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "195px"
    },
    attrs: {
      "min": 0,
      "precision": 3,
      "step": 0.5,
      "label": "请输入总学分"
    },
    model: {
      value: (_vm.settingForm.totalCredit),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "totalCredit", $$v)
      },
      expression: "settingForm.totalCredit"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.settingDialogVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-592d72de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/baseInfo/student/graduateRequire.vue
// module id = 1838
// module chunks = 502